"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPersonalizationTokenMeta = exports.encodeTokenMeta = exports.PersonalizationTokenMetaTwigSource = void 0;
const uuid_1 = require("uuid");
var PersonalizationTokenMetaTwigSource;
(function (PersonalizationTokenMetaTwigSource) {
    PersonalizationTokenMetaTwigSource["PREVIEW"] = "preview";
    PersonalizationTokenMetaTwigSource["CODE"] = "code";
    PersonalizationTokenMetaTwigSource["TOKEN_CODE"] = "tokenCode";
})(PersonalizationTokenMetaTwigSource = exports.PersonalizationTokenMetaTwigSource || (exports.PersonalizationTokenMetaTwigSource = {}));
function encodeTokenMeta(tokenMeta) {
    return getBase64(JSON.stringify(tokenMeta));
}
exports.encodeTokenMeta = encodeTokenMeta;
function createPersonalizationTokenMeta(contactId, metaTwigSource, fallbackText = '') {
    const defaultPipe = fallbackText ? ` | default("${fallbackText}")` : '';
    const twig = `{{ contact.${contactId}${defaultPipe} }}`;
    const name = (0, uuid_1.v4)();
    return {
        tokenName: name,
        type: 'personalization',
        token: {
            name: name,
            code: `{{ contact.${contactId} }}`,
            filters: fallbackText ? { fallback: fallbackText, index: 0 } : {},
            source: 'contact',
            content: { field: contactId },
        },
        ...(metaTwigSource === PersonalizationTokenMetaTwigSource.PREVIEW ? { preview: twig } : {}),
        ...(metaTwigSource === PersonalizationTokenMetaTwigSource.CODE ? { code: twig } : {}),
    };
}
exports.createPersonalizationTokenMeta = createPersonalizationTokenMeta;
function getBase64(text) {
    return Buffer.from(text).toString('base64');
}
//# sourceMappingURL=factory.js.map